import { getFormattedLinkToBrowser } from '~/utils/url';

export const GENERAL_CONDITIONS_LINK = getFormattedLinkToBrowser(
  'https://www.marisa.com.br/downloads/PDFs/condicoes-gerais-contratacao.pdf'
);
